import { render, staticRenderFns } from "./rejectCase.vue?vue&type=template&id=4652bd00&"
import script from "./rejectCase.vue?vue&type=script&lang=js&"
export * from "./rejectCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4652bd00')) {
      api.createRecord('4652bd00', component.options)
    } else {
      api.reload('4652bd00', component.options)
    }
    module.hot.accept("./rejectCase.vue?vue&type=template&id=4652bd00&", function () {
      api.rerender('4652bd00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/case/handing/rejectCase.vue"
export default component.exports